export class ImobiliariaDetalhadaResponse {
  id: number;
  nomeFantasia: string;
  razaoSocial: string;
  cpfCnpj: string;
  email: string;
  telefone: string;
  cep: string;
  endereco: string;
  numero: string;
  complemento: string;
  bairro: string;
  cidade: string;
  estado: string;
  codigoConvite: string;
  planoId: number;
  ativoFlag: boolean;

  constructor(p: any) {
    this.id = p.id ?? null;
    this.nomeFantasia = p.nomeFantasia ?? null;
    this.razaoSocial = p.razaoSocial ?? null;
    this.cpfCnpj = p.cpfCnpj ?? null;
    this.email = p.email ?? null;
    this.telefone = p.telefone ?? null;
    this.cep = p.cep ?? null;
    this.endereco = p.endereco ?? null;
    this.numero = p.numero ?? null;
    this.complemento = p.complemento ?? null;
    this.bairro = p.bairro ?? null;
    this.cidade = p.cidade ?? null;
    this.estado = p.estado ?? null;
    this.codigoConvite = p.codigoConvite ?? null;
    this.planoId = p.planoId ?? null;
    this.ativoFlag = p.ativoFlag ?? true;
  }
}
